import { render, staticRenderFns } from "./ClinicalAsam.vue?vue&type=template&id=5303c946&"
import script from "./ClinicalAsam.vue?vue&type=script&lang=js&"
export * from "./ClinicalAsam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports